// extracted by mini-css-extract-plugin
module.exports = {"Menu":"bgg_a bgu_h","Menu__offsetParent":"bgg_b bgu_bj","Menu__trigger--shadowed":"bgg_c"};